export default from './more-button';



// WEBPACK FOOTER //
// ./app/components/more-button/index.js